import type { Period, DateRange } from '../components/dashboard/types';

export function getDateRange(period: Period): DateRange {
  const now  = new Date();
  const to   = now.toISOString();
  let   from: Date;

  switch (period) {
    case 'Today':
      from = new Date(now);
      from.setHours(0, 0, 0, 0);
      break;
    case 'This week': {
      from = new Date(now);
      const day = from.getDay() === 0 ? 6 : from.getDay() - 1;
      from.setDate(from.getDate() - day);
      from.setHours(0, 0, 0, 0);
      break;
    }
    case 'This month':
      from = new Date(now.getFullYear(), now.getMonth(), 1);
      break;
    case 'This year':
      from = new Date(now.getFullYear(), 0, 1);
      break;
    default:
      from = new Date(now);
      from.setDate(from.getDate() - 7);
  }

  return { from: from.toISOString(), to };
}


export function formatBucketLabel(bucket: string, period: Period): string {
  const date = new Date(bucket);
  switch (period) {
    case 'Today':
      return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
    case 'This week':
      return date.toLocaleDateString('en-GB', { weekday: 'short' });
    case 'This month':
      return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    case 'This year':
      return date.toLocaleDateString('en-GB', { month: 'short' });
    default:
      return bucket;
  }
}


export function prevPeriodLabel(period: Period): string {
  switch (period) {
    case 'Today':      return 'vs yesterday';
    case 'This week':  return 'vs last week';
    case 'This month': return 'vs last month';
    case 'This year':  return 'vs last year';
  }
}


export function getPrevDateRange(period: Period): DateRange {
  const now = new Date();

  switch (period) {
    case 'Today': {
      const from = new Date(now);
      from.setDate(from.getDate() - 1);
      from.setHours(0, 0, 0, 0);
      const to = new Date(from);
      to.setHours(23, 59, 59, 999);
      return { from: from.toISOString(), to: to.toISOString() };
    }
    case 'This week': {
      const currentFrom = new Date(now);
      const day = currentFrom.getDay() === 0 ? 6 : currentFrom.getDay() - 1;
      currentFrom.setDate(currentFrom.getDate() - day);
      currentFrom.setHours(0, 0, 0, 0);
      const from = new Date(currentFrom);
      from.setDate(from.getDate() - 7);
      const to = new Date(currentFrom);
      to.setMilliseconds(-1);
      return { from: from.toISOString(), to: to.toISOString() };
    }
    case 'This month': {
      const from = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const to   = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59, 999);
      return { from: from.toISOString(), to: to.toISOString() };
    }
    case 'This year': {
      const from = new Date(now.getFullYear() - 1, 0, 1);
      const to   = new Date(now.getFullYear() - 1, 11, 31, 23, 59, 59, 999);
      return { from: from.toISOString(), to: to.toISOString() };
    }
  }
}
